<template>
  <div class="week-bar-graph">
    <div
      class="week-bar"
      v-for="(day, dayIndex) in weekData"
      :key="dayIndex"
    >
      <div class="bar-wrapper">
        <!-- Цель -->
        <div
          class="goal-bar"
          :style="{ height: (day.targetCount / maxValue) * 200 + 'px' }"
        >
          <span v-if="day.targetCount && day.targetCount > day.stepsCount" class="bar-label target">
            {{ formatNumber(day.targetCount) }}
          </span>
        </div>

        <!-- Факт -->
        <div
          class="progress-bar"
          :style="{
            height: (day.stepsCount / maxValue) * 200 + 'px',
            backgroundColor: getProgressColor(day.stepsCount, day.targetCount)
          }"
        >
          <span v-if="day.stepsCount" class="bar-label steps">
            {{ day.stepsCount }}
          </span>
        </div>
      </div>

      <div class="day-label">
        {{ weekDays[dayIndex] }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WeekBarGraph',
  props: {
    weekData: {
      type: Array,
      required: true,
    },
    weekDays: {
      type: Array,
      default: () => ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
    },
  },
  computed: {
    maxValue() {
      return Math.max(
        ...this.weekData.map((day) => Math.max(day.stepsCount || 0, day.targetCount || 0)),
      );
    },
  },
  methods: {
    formatNumber(num) {
      if (num >= 1000000) return `${Math.floor(num / 100000) / 10}M`;
      if (num >= 1000) return `${Math.floor(num / 1000)}K`;
      return num.toString();
    },
    getProgressColor(steps, target) {
      const percentage = (steps / target) * 100;
      if (percentage <= 49) return '#B5EB8F';
      if (percentage <= 99) return '#93DE64';
      return '#71D13D';
    },
  },
};
</script>

<style scoped>
.week-bar-graph {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 240px;
  width: 350px;
  margin: 0 auto;
  margin-bottom: 40px;
  @media (max-width: 500px) {
    width: 100%;
    max-width: 320px;
  }
}

.week-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 12%;
}

.bar-wrapper {
  position: relative;
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.goal-bar {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: rgba(1, 1, 1, 0.04);
  border-radius: 8px 8px 0 0;
  z-index: 2;
}

.progress-bar {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-radius: 8px 8px 0 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-size: 12px;
  color: white;
}

.bar-label {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  line-height: 18px;
  letter-spacing: 5%;
  color: rgba(1, 1, 1, 0.45);
  &.target {
    font-size: 6px;
    top: -16px;
  }
  &.steps {
    font-size: 8px;
    font-weight: 600;
    top: 0;
  }
}

.day-label {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: rgba(1, 1, 1, 0.45);
}
</style>
